import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Button, Grid, TablePagination, Tooltip, Typography } from "@mui/material";
import { truncateComment } from 'utils/utils';
import pick from "assets/images/pickUp.svg";
import drop from "assets/images/drop.svg";


function HomeRideInfo(props) {
  const navigate = useNavigate();
  const  tripData  = props?.tripData;
const handleChange = (event,data) =>{
  navigate('/myride/details',{state:{id:data?.id}})
}
const handleChangePage = (event, newPage) => {
  props.handleChangePage(event, newPage);
};

const handleChangeRowsPerPage = (event) => {
  props?.handleChangeRowsPerPage(event);
};
  return (
    <Grid container className="marginBlock10">
     {tripData && tripData?.map((trip) => 
      <Grid
        item
        direction="column"
        justifyContent="space-evenly"
        alignItems="center"
        className="boxShadow padding20 marginInline10"
        md={3.5}  xs={12}
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="paddingBlock10"
          md={12}
        >
          <Typography className="colorBlue">{moment(trip?.scheduledTime).format('DD MMM YYYY, hh:mm a')}</Typography>
          <Typography 
          className={`fontMedium 
          ${trip?.status === 'Completed'?
           'colorGreen'
           :
           trip?.status === 'Cancelled' ? 
           'colorRed' 
            : 
           'colorBlue'
            } `}>{trip?.status} </Typography>
        </Grid>
        <Grid
          item
          container
          direction="column"
          justifyContent="space-between"
          className="paddingBlock10"
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            className="marginBottom7"
          >
            <Grid item xs={0.5} className="pickUpItem">
              <img src={pick} alt="star" className="pickUpPosition" />
            </Grid>
            <Grid item xs={11}>
              <Tooltip title={trip?.sourceAddress} placement="bottom">
                {truncateComment(trip?.sourceAddress, 25)}
              </Tooltip>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Grid item xs={0.5}>
              <div className="dropImg">
                <img src={drop} alt="star" />
              </div>
            </Grid>
            <Grid item xs={11}>
              <Tooltip title={trip?.destinationAddress} placement="bottom">
                {truncateComment(trip?.destinationAddress, 25)}
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          className="paddingBlock10"
        >
          <Typography>{trip?.carType}</Typography>
          <Button
          className="greyButton" onClick={(event) =>handleChange(event,trip)}>View Details </Button>
        </Grid>
      </Grid>
      )}
      {
        props?.totalCount > 10 && 
        (<Grid item
        md={8}>

           <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={props?.totalCount}
            rowsPerPage={props?.rowsPerPage}
            page={props?.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          
          />
          </Grid>
       )} 
    </Grid>
  );
}

export default HomeRideInfo;
